/* global G */
import ui from 'lib/hook/ui/update'
import platform from 'app/_shared/hook/platform'
import multiCreate from 'app/_shared/hook/appbar/multiCreate'
import quickActions from 'app/_shared/hook/appbar/quickActions'
import setSearchFieldConfig from 'app/equipmentInformation/hook/setSearchFieldConfig'
import reset from 'lib/hook/model/reset'
import search from 'app/_shared/hook/appbar/search'
import recall from 'app/_shared/hook/component/recall'

const _baseHooks = {
  before: [
    platform({
      mobile: [quickActions, multiCreate],
    }),
  ],
  after: [
    ui,
  ],
}

const _searchHooks = {
  before: [
    setSearchFieldConfig({
      runOnVisibilityChange: false,
    }),
    platform({
      mobile: [
        reset,
        search,
      ],
    }),
    recall,
  ],
  after: [
    ui,
    setSearchFieldConfig({
      runOnVisibilityChange: true,
    }),
  ],
}

const hooks = {
  [G.ACTIONS]: {
    index: _baseHooks,
    search: _searchHooks,
    demo: _baseHooks,
  },
}

export default hooks
